import { useOutletContext } from "react-router-dom";
import { Field, Input, Button } from "@/admin/ui";
import { useUserAuth } from "@/user/UserAuthContext";

export default function CaProfile() {
    const { user, company } = useOutletContext();
    const { logout } = useUserAuth();

    return (
        <div data-testid="ca-profile-page">
            <div className="max-w-3xl">
                <div className="inline-flex items-center gap-3 text-[11px] font-semibold tracking-[0.22em] uppercase text-neutral-500">
                    <span className="h-px w-6 bg-neutral-300" />
                    Profile
                </div>
                <h1 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-black">
                    {user.name}
                </h1>
                <p className="mt-3 text-[14px] text-neutral-600">Company Admin · {company?.name}</p>
            </div>

            <div className="mt-8 space-y-5">
                <Section title="Identity">
                    <Field label="Full Name"><Input defaultValue={user.name} onChange={() => {}} /></Field>
                    <Field label="Email"><Input value={user.email} readOnly /></Field>
                    <Field label="Phone"><Input defaultValue={user.phone || ""} onChange={() => {}} /></Field>
                    <Field label="Role"><Input value="Company Admin" readOnly /></Field>
                </Section>

                <Section title="Security">
                    <Field label="Password"><Input value="••••••••" readOnly /></Field>
                    <Field label="Two-Factor Authentication">
                        <Input value="Coming soon" readOnly />
                    </Field>
                    <div className="sm:col-span-2 flex flex-wrap gap-2">
                        <Button variant="ghost" onClick={() => alert("Contact your platform admin to change your password.")}>
                            Change Password
                        </Button>
                    </div>
                </Section>

                <div className="flex justify-end gap-2">
                    <Button variant="ghost" onClick={() => alert("Profile saved (placeholder).")}>Save</Button>
                    <Button variant="danger" onClick={logout} data-testid="ca-profile-logout">Logout</Button>
                </div>
            </div>
        </div>
    );
}

function Section({ title, children }) {
    return (
        <div className="glass rounded-3xl p-6 sm:p-8">
            <div className="text-[10px] font-semibold tracking-[0.22em] uppercase text-violet-600">{title}</div>
            <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-4">{children}</div>
        </div>
    );
}
